import React from "react";
import i18n from "../../../../constants/i18n";
import { EVENTS_CHARTS_DAILY_STATS } from "../../../../constants/table-custom-headers/Auditor";
import Et3BarChart from "../../../../core/et3-chart/Et3BarChart";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import getEventsChartStore from "../../../../stores/auditor-store/events-chart-store";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const EventsChartsData = withLiteObserverAndTheme(() => {
  const eventsData = getEventsChartStore().adminEventsChartsData.get();
  const labels = eventsData.eventsStatistics.map(
    (item) => `${item.customDate}`
  );
  const values = eventsData.eventsStatistics.map((item) => item.total);
  const dailyStatistics =
    getEventsChartStore().getEventsChartTableDailyStatistcs();

  return (
    <React.Fragment>
      <Et3Table
        columns={EVENTS_CHARTS_DAILY_STATS}
        rows={dailyStatistics}
        title={i18n.get("DAILY_STATS")}
        shouldBeFlagged={false}
        titleKey={"DAILY_STATS"}
      />
      <Et3Margin top={50} bottom={0} left={0} right={0} />
      <Et3BarChart
        dataLabels={labels}
        values={values}
        title={i18n.get("ADMIN_EVENTS")}
      />
    </React.Fragment>
  );
});
export default EventsChartsData;
